module.exports = __webpack_public_path__ + "img/diy-YiIhJyGk.0a31ce34.svg";